export enum PaymentType {
    Domiciliation = 'domiciliation',
    Transfer = 'transfer',
}
